let React = require("react");
export const DoubleClickAd = () => {
    let [adId] = React.useState(Math.floor(Date.now() / 1000));
    return (
        <iframe
            src={`https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B22121483.248409022;sz=728x90;ord=[${adId}];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`}
            scrolling="no"
            marginHeight="0"
            marginWidth="0"
            height="90"
            width="728"
            allowtransparency="1"
            style={{
                margin: "30px auto 0",
                border: "none"
            }}
        >
            <script
                src={`https://ad.doubleclick.net/ddm/adi/N718679.3040413THENOUNPROJECT.CO/B22121483.248409022;sz=728x90;ord=[${adId}];dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=?`}
            />
        </iframe>
    );
};
